import { render, staticRenderFns } from "./DepositMovements.vue?vue&type=template&id=a963f70e&"
import script from "./DepositMovements.vue?vue&type=script&lang=js&"
export * from "./DepositMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports